
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

const UNSPLASH_ACCESS_KEY = 'kX1QZ-2vx8QwJsWNfY5YlvfOU5j6K_Pc5FX0n6YmBww';

interface UnsplashImage {
  id: string;
  urls: {
    raw: string;
    full: string;
    regular: string;
    small: string;
    thumb: string;
  };
  alt_description: string;
  user: {
    name: string;
    username: string;
  };
}

export function useUnsplashImages(query: string = '', page: number = 1) {
  const [totalPages, setTotalPages] = useState(0);

  const fetchImages = async (): Promise<UnsplashImage[]> => {
    const response = await fetch(
      `https://api.unsplash.com/search/photos?query=${query}&page=${page}&per_page=20`,
      {
        headers: {
          Authorization: `Client-ID ${UNSPLASH_ACCESS_KEY}`
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch images');
    }

    const data = await response.json();
    setTotalPages(data.total_pages);
    return data.results;
  };

  return useQuery({
    queryKey: ['unsplash', query, page],
    queryFn: fetchImages,
    enabled: !!query
  });
}
